export default __webpack_public_path__ + "static/char-s-34-ko-157ed9f071e532823bd501900c321eee.png";